import React from 'react';

export const FieldError = ({ msg }) =>
    msg ? <p className="mt-1 text-xs text-red-600">{msg}</p> : null;

export const FieldWrap = ({ icon: Icon, children }) => (
    <div className="relative">
        {Icon && (
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Icon className="h-4 w-4 text-gray-400" />
            </div>
        )}
        {children}
    </div>
);

export const cls = (err, icon = true) =>
    `w-full px-3 py-2.5 ${icon ? 'pl-9' : ''} border ${err ? 'border-red-400' : 'border-gray-300'} rounded-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white`;

export const Spinner = () => (
    <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
);

export const getErr = (obj, field) =>
    obj[field] ? (Array.isArray(obj[field]) ? obj[field][0] : obj[field]) : null;
